import {Injectable, signal} from '@angular/core';
import {CertificateFile} from "../types/certificate-modal.types";

@Injectable({
  providedIn: 'root'
})
export class CertificateFilesStateService {
  private _certificateFilesState = signal<Record<number, Array<CertificateFile>>>({});
  public certificateFilesState = this._certificateFilesState.asReadonly();

  public setCertificateFilesState(id: number, certificateFiles: Array<CertificateFile>): void {
    this._certificateFilesState.set({
      ...this._certificateFilesState(),
      [id]: certificateFiles
    });
  }

  public getCertificateFilesById(id: number): Array<CertificateFile> {
    return this.certificateFilesState()[id];
  }

  public deleteFileById(fileId: number, certificateId: number): void {
    this._certificateFilesState.update(state => {
      const currentFiles = state[certificateId] || [];
      const updatedFiles = currentFiles.filter(file => file.id !== fileId);

      return {
        ...state,
        [certificateId]: updatedFiles
      };
    });
  }

  public updateCertificateFilesState(certificateId: number, certificateFile: CertificateFile): void {
    this._certificateFilesState.update(state => {
      const currentFiles = state[certificateId] || [];
      const updatedFiles = [...currentFiles, certificateFile];

      return {
        ...state,
        [certificateId]: updatedFiles
      };
    });
  }

  public deleteCertificateFilesState(certificateId: number): void {
    this._certificateFilesState.update(state => {
      const newState = { ...state };
      delete newState[certificateId];
      return newState;
    });
  }
}
